import "./Home.module.css";
import Naglowek from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutUsPreview from "./sections/AboutUsPreview";
import NaszeUslugi from "./sections/NaszeUslugi";
import ServicesGrid from "./sections/ServicesGrid";
import OpinionKliencien from "./sections/OpinionKliencien";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import ContactUsSection from "./sections/ContactUsSection";
import Stopka from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Naglowek />
      <Hero />
      <AboutUsPreview />
      <NaszeUslugi />
      <ServicesGrid />
      <OpinionKliencien />
      <FrequentlyAskedQuestions />
      <ContactUsSection />
      <Stopka />
    </div>;
}